import React from 'react';

const META_APP_ID = process.env.REACT_APP_META_APP_ID; // Substitua pelo seu App ID
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI; // Deve ser a mesma URL configurada no painel da Meta

const SocialConnectPage = () => {

  const handleConnect = () => {
    const scope = 'instagram_business_basic, instagram_business_manage_insights';
    
    const authUrl = `https://www.instagram.com/oauth/authorize?client_id=${META_APP_ID}&redirect_uri=${REDIRECT_URI}&scope=${scope}&response_type=code`;
    
    window.location.href = authUrl;
  };

  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>Conectar sua Conta do Instagram</h1>
      <p>Para sincronizar seus posts, insights e comentários, você precisa autorizar nosso aplicativo.</p>
      <button 
        onClick={handleConnect} 
        style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}
      >
        Conectar com Instagram
      </button>
    </div>
  );
};

export default SocialConnectPage;
